import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { Captions, SubHeadline } from '~components/Typography';

import { heightList } from '../constants';
import type { Size } from '../types';

export const Icon = styled(SubHeadline)`
	&:not(.disabledIconStyles) {
		display: flex;
		height: var(--button-icon-size);
		padding: var(--button-icon-padding);
		& > * {
			width: auto;
			height: 100%;
		}
	}
`;

const content = `
	display: flex;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	user-select: none;`;

export const MainContent = styled(SubHeadline)`
	${content}
`;
export const MainContentCaptions = styled(Captions)`
	${content}
`;

const generateStyle = (size: Size) => `
	height: ${heightList[size]};
`;

export const styledButton = css`
	&.skeleton-on {
		overflow: hidden;
		border-color: transparent !important;
		background: transparent !important;
		cursor: default;
		pointer-events: none;
	}

	&.skeleton-on *:not(.skeleton) {
		opacity: 0;
	}

	&.sizeBadge {
		${generateStyle('Badge')}
	}

	&.sizeS {
		${generateStyle('S')}
	}

	&.sizeM {
		${generateStyle('M')}
	}

	&.sizeL {
		${generateStyle('L')}
	}
`;

export const skeletonStyle = css`
	position: absolute;
`;
